import React from 'react';
import { Target, Lightbulb, Users } from 'lucide-react';
import { IMAGES } from '../utils/constants';

const About = () => {
    return (
        <div className="page-wrapper">
            <div className="page-header">
                <div className="container text-center">
                    <h1 className="page-title">About Our Academy</h1>
                    <p className="page-subtitle">Dedicated to fostering a love for learning in every child.</p>
                </div>
            </div>

            <div className="container section">
                <div className="grid grid-cols-2 mobile-stack gap-12">
                    <div>
                        <h2 className="section-title">Who We Are</h2>
                        <p className="section-desc">
                            Little Star Kids Academy focuses on developing better standards of curriculum and
                            constantly updating newer methods to better the kids' schooling experience.
                            We believe every child is unique and deserves an environment where they can
                            shine the brightest.
                        </p>
                        <p className="section-desc">
                            Our holistic approach ensures that children not only excel academically but also
                            develop emotionally, socially, and physically.
                        </p>
                    </div>
                    <div className="img-card rotation-right">
                        <img src={IMAGES.aboutMain} alt="Teacher and students" className="rounded-img" />
                    </div>
                </div>
            </div>

            {/* Vision, Mission, Approach */}
            <div className="section bg-subtle">
                <div className="container">
                    <div className="grid grid-cols-3 gap-8">
                        <div className="card text-center">
                            <div className="icon-box bg-primary-light">
                                <Target size={32} className="text-white" />
                            </div>
                            <h3 className="card-title">Our Vision</h3>
                            <p className="card-text">
                                To be the leading preschool provider, known for our innovative curriculum
                                and commitment to child development excellence.
                            </p>
                        </div>
                        <div className="card text-center">
                            <div className="icon-box bg-accent-light">
                                <Lightbulb size={32} className="text-white" />
                            </div>
                            <h3 className="card-title">Our Mission</h3>
                            <p className="card-text">
                                To provide a safe, nurturing, and stimulating environment where children
                                can explore, learn, and grow into confident individuals.
                            </p>
                        </div>
                        <div className="card text-center">
                            <div className="icon-box bg-secondary-light">
                                <Users size={32} className="text-white" />
                            </div>
                            <h3 className="card-title">Our Values</h3>
                            <p className="card-text">
                                Passion for education, respect for every child, transparency with parents,
                                and integrity in all our actions.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
        .page-header {
          background-color: var(--color-primary-light);
        }

        .bg-primary-light { background-color: var(--color-primary); }
        .bg-accent-light { background-color: var(--color-accent); }
        .bg-secondary-light { background-color: var(--color-secondary-dark); }

        .icon-box {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          box-shadow: var(--shadow-md);
        }

        .card-title {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .card-text {
          color: var(--color-text-light);
        }

        .rotation-right { transform: rotate(3deg); }
        .rounded-img { border-radius: 1.5rem; width: 100%; height: auto; display: block; }
        
        .mobile-stack {
          align-items: center;
        }

        @media (max-width: 960px) {
          .mobile-stack, .grid-cols-3 {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
        </div>
    );
};

export default About;
